<template>
  <v-container class="d-flex align-center wallet-badge" @click="goToWallet">
    <v-icon color="white">mdi-wallet</v-icon>
    <span class="mr-3 ml-1">
      <span class="wallet-text mr-1">{{ this.btc }}</span>
      <span class="wallet-text">BTC</span>
    </span>
    <span class="mr-3">
      <span class="wallet-text mr-1">{{ this.total }}</span>
      <span class="wallet-text">USDT</span>
    </span>
    <span v-if="kucoin !== null">
      <span class="wallet-text mr-1">{{ this.kucoin }}</span>
      <span class="wallet-text">USDT (KuCoin)</span>
    </span>
  </v-container>
</template>

<script>
import { balanceService } from '@/services/BalanceService'
import { mapGetters } from 'vuex'
// import { config } from '@/config'

export default {
  data () {
    return {
      timerBalance: null,
      btc: 0,
      total: 0,
      kucoin: null
    }
  },
  mounted () {
    this.getBTC()
  },
  computed: {
    ...mapGetters(['isLogged'])
  },
  methods: {
    goToWallet () {
      if (this.$route.path !== '/wallet') this.$router.push('/wallet')
    },
    getBTC () {
      if (this.isLogged) {
        balanceService.getCurrentUserBalance().then(res => {
          this.btc = (res && res.data) ? res.data.totalBtc : 0
          this.total = (res && res.data) ? res.data.totalUsdt : 0
          this.kucoin = (res && res.data && res.data.kucoinUsdt != null) ? res.data.kucoinUsdt : null
        })
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timerBalance)
  }
}
</script>

<style scoped>
.wallet-badge {
  width: auto;
  border: 1px solid rgba(255, 255, 255, 0.7);
  padding: 3px;
  border-radius: 10px;
  cursor: pointer;
}
.wallet-text {
  font-size: 12px;
  color: white;
}
</style>
